module.exports = __webpack_public_path__ + "static/media/company-logo-placeholder.6a68d538.svg";